<template>
  <div>
    <div class="opc-cart__total" v-if="mx_is">
      <div class="opc-cart__total__discount" v-if="totalProratedDiscount > 0">
        <div class="opc-cart__total__text">{{ $t('billing.coupon.discount') }}</div>
        <div class="text-no-capitalize" style="color: #247F40;">
          <vloader :loading="mx_loading" :value="`- ${$money(totalProratedDiscount)}`" />
        </div>
      </div>
      <refer-a-friend-referral-credit />
      <div class="opc-cart__total__tax">
        <div class="opc-cart__total__text __PLACEHOLDER_total__tax">
          {{ $t('billing.estimated_tax') }}
          <!-- tooltip start -->
          <zm-tooltip role="button" aria-label="learn more about Estimated Tax" :popper-options="{ boundariesElement: 'scrollParent' }" v-if="hasZoomDevice">
            <i class="zm-icon-info-outline" style="position: relative; top: -1px; color: #666487; font-size: 16px" />
            <div class="zm-tooltip__content zm-tooltip__content-total" slot="content">
              <p>{{ $t('billing.hw.desk_phones.tax.zoom_tax_amount', { amount: $money(getTaxTotalAmount) }) }}</p>
              <p>{{ $t('billing.hw.hardware_tax_amount', { amount: $money(getDeskphoneTaxTotalAmount) }) }}</p>
            </div>
          </zm-tooltip>
          <div class="tooltip-container only-show-in-success inline-block" data-position="top" v-if="hasZoomDevice">
            <i class="zm-icon-info-outline" style="position: relative; top: -1px; color: #666487; font-size: 16px"/>
            <div class="tooltip zm-tooltip__content">
              <p>{{ $t('billing.hw.desk_phones.tax.zoom_tax_amount', { amount: $money(getTaxTotalAmount) }) }}</p>
              <p>{{ $t('billing.hw.hardware_tax_amount', { amount: $money(getDeskphoneTaxTotalAmount) }) }}</p>
            </div>
          </div>
          <!-- tooltip end -->
        </div>
        <div class="opc-cart__total__text text-no-capitalize">
          <vloader :loading="mx_loading" :value="$money(updatedTaxAmount)" />
        </div>
      </div>
      <div class="opc-cart__total__sub">
        <div class="opc-cart__total__text">
          {{ this.$t('billing.order_summary.total') }}
        </div>
        <div class="opc-cart__total__text text-no-capitalize">
          <vloader :loading="mx_loading" :value="$money(subTotal)" />
        </div>
      </div>
      <div class="opc-cart__total__credit--transaction" v-if="applicableRefundCredit > 0.01">
        <div class="opc-cart__total__text text-no-capitalize">
          {{ this.$t('billing.prorated.transaction_credit_applied') }}
          <zm-tooltip :content="$t('billing.prorated.transaction_credit_tip', [displayPeriod])" role="button" aria-label="learn more about Credit Applied">
            <i class="zm-icon-info-outline" style="position: relative; top: -1px; color: #666487; font-size: 16px" />
          </zm-tooltip>
        </div>
        <div class="opc-cart__total__text">
          <vloader :loading="mx_loading" :value="`- ${$money(applicableRefundCredit)}`" />
        </div>
      </div>
      <div class="opc-cart__total__credit--existing" v-if="applicableAccountCredit > 0.01">
        <div class="opc-cart__total__text">
          {{ this.$t('billing.prorated.existing_credit_applied') }}
        </div>
        <div class="opc-cart__total__text">
          {{ `- ${$money(applicableAccountCredit)}` }}
        </div>
      </div>
      <div class="opc-cart__total__alert" v-if="applicableAccountCredit > 0.01 || remainingRefundCredit > 0.01">
        <span
          class="opc-cart__total__alert__text"
          v-html="$t('billing.prorated.remaining_credit', [`<b>${$money(futureAccountCredit)}</b>`])"
        />
        <span class="opc-cart__total__alert__text" v-if="remainingRefundCredit">
          {{ this.$t('billing.prorated.refund_credit_usage') }}
        </span>
      </div>
      <div class="opc-cart__total__main">
        <div class="opc-cart__total__text">
          {{ this.$t('billing.order_summary.todays_total') }}
          <tooltip v-if="todaysTotal" />
        </div>
        <div class="opc-cart__total__text text-no-capitalize">
          <vloader :loading="mx_loading" :value="$money(todaysTotal)" />
        </div>
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import tooltip from './tooltip.vue';
import { mapGetters } from 'vuex';
import mx from './mx.vue';
import mxTotal from '../total.vue';
import { dateTimeFormat } from '@/utils/dateformat';
import vloader from './vloader.vue';
import { PRORATED_OF } from '@/store/modules/preview';
import ReferAFriendReferralCredit from '../refer-a-friend-referral-credit/index.vue';
export default {
  mixins: [mx, mxTotal], // TODO reuse tax reload, but this is ugly
  components: {
    vloader,
    tooltip,
    ReferAFriendReferralCredit,
  },
  computed: {
    ...mapGetters([
      'getSelectedPlans',
      'getTodaysTotal',
      'getProratedChargeTaxAmount',
      'getProratedChargeSubTotal',
      'getRefundCredit',
      'getCreditBalance',
      'getIsReplaceSubscription',
      'getProratedChargeDetails',
      'accountWithCouponDiscount',
      'hasZoomDevice',
      'getDeskphoneTaxTotalAmount'
    ]),
    deviceTotalAmount() {
      const devicePlans = this.getSelectedPlans.filter(item => item.isVendorProduct);
      return devicePlans.reduce((acc, x) => {
        return acc + x.amount * x.cartInfo.selected_number;
      }, 0);
    },
    offsetTax() {
      if (this.accountWithCouponDiscount) return 0;
      if (!this.mx_isSingleIncreaseLicense) return 0;
      return this.getProratedChargeDetails
        .filter((x) => x.of === PRORATED_OF.CURRENT)
        .reduce((acc, x) => {
          return acc + x.tax;
        }, 0);
    },
    offsetTotal() {
      if (this.accountWithCouponDiscount) return 0;
      if (!this.mx_isSingleIncreaseLicense) return 0;
      return this.getProratedChargeDetails
        .filter((x) => x.of === PRORATED_OF.CURRENT)
        .reduce((acc, x) => {
          return acc + x.chargeAmount;
        }, 0) + this.offsetTax;
    },
    subTotal() {
      return this.getProratedChargeSubTotal + this.offsetTotal + this.deviceTotalAmount;
    },
    refundCredit(){
      return this.getRefundCredit + this.offsetTotal;
    },
    zoomTaxAmount() {
      return (
        this.getProratedChargeDetails
          .filter((x) => x.of === PRORATED_OF.UPDATED)
          .reduce((acc, x) => {
            return acc + x.tax;
          }, 0) + this.offsetTax
      );
    },
    updatedTaxAmount() {
      return this.zoomTaxAmount + this.getDeskphoneTaxTotalAmount;
    },
    applicableRefundCredit() {
      if (this.refundCredit <= 0) return 0;
      return Math.min(this.refundCredit, this.subTotal);
    },
    remainingRefundCredit() {
      return this.refundCredit - this.applicableRefundCredit;
    },
    isAccountCreditApplicable() {
      return !this.getIsReplaceSubscription;
    },
    applicableAccountCredit() {
      if (!this.isAccountCreditApplicable) return 0;
      if (this.getCreditBalance == 0) return 0;
      return Math.min(this.subTotal - this.applicableRefundCredit, this.getCreditBalance);
    },
    futureAccountCredit() {
      return this.getCreditBalance - this.applicableAccountCredit + this.remainingRefundCredit;
    },
    displayPeriod() {
      if(this.getSelectedPlans.length > 1) return '';
      const from = dateTimeFormat(new Date());
      const detail = this.getProratedChargeDetails.find((x) => x.of === PRORATED_OF.CURRENT); // TODO depends on that existing plans will be refunded at the same time
      if (!detail) return '';
      const to = dateTimeFormat(new Date(detail.prorationEndDate));
      return ` (${from} - ${to})`;
    },
    todaysTotal(){
      return Math.max(this.getTodaysTotal + this.deviceTotalAmount, 0);
    },
    totalProratedDiscount() {
      return this.getProratedChargeDetails
        .filter((x) => x.of === PRORATED_OF.UPDATED)
        .reduce((acc, x) => {
          return acc + x.discountAmount;
        }, 0);
    },
  },
};
</script>
<style lang="scss">
.zm-tooltip__content-total {
  padding: 8px 4px;
  p {
    // text-align: center;
    // width: 268px;
    color: var(--day-foreground-foreground-ada, #666487);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 16.8px */
  }
}
</style>
<style lang="scss" scoped>
.only-show-in-success {
  display: none;
}
</style>
